/**
 * Formats a given amount as a currency string.
 *
 * @deprecated This function is deprecated and will be removed in future versions. You should use `@upgrade/ui-utils/formatters/lingui/price` instead.
 *
 * @param {number|string} amount - The amount to format.
 * @param {Object} [options] - Formatting options.
 * @param {boolean} [options.showCurrency=true] - Whether to show the currency symbol.
 * @param {number} [options.digits=2] - Number of decimal digits to display.
 * @param {boolean} [options.smart=false] - Whether to use smart formatting for integers.
 * @returns {string|null} The formatted currency string, or null if the amount is not a finite number.
 */
export default ((amount, {
  showCurrency = true,
  digits = 2,
  smart = false
} = {}) => {
  const parsed = parseFloat(amount);
  if (!Number.isFinite(parsed)) {
    return null;
  }
  const isSmartInt = smart && Number.isInteger(parsed);
  const formatted = parsed.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: isSmartInt ? 0 : digits,
    maximumFractionDigits: isSmartInt ? 0 : digits
  });
  if (!showCurrency) {
    return formatted.replace(/\$/g, '');
  }
  return formatted;
});